require('./services/google-pay');

module.exports = 'google-pay';



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/google-pay/index.js
 ** module id = 105
 ** module chunks = 1
 **/